import React from 'react';
import classnames from 'classnames';

import Icon from 'assets/icons';

import styles from './AlertIcon.module.scss';

interface AlertIconProps {
  /** @string - color of background circle */
  bgColor?: string;
  /** @string - className for components wrapper */
  className?: string;
  /** @string - determins size */
  size?: string;
  /** @string - determins status */
  status?: string;
  /** @function - Called when button is clicked */
  onClick?: any;
}

const AlertIcon: React.FC<AlertIconProps> = ({ bgColor, className, size, status, onClick }) => {
  return (
    <div className={classnames(
      className, 
      styles.container, {
        [styles[`bgColor--${bgColor}`]]: bgColor,
        [styles[`size--${size}`]]: size
      }
    )}
      onClick={onClick}
    >
      {status === "Complete"
        ? <Icon.CheckmarkRounded />
        : <Icon.Exclamation />
      }
    </div>
  )
}

export default AlertIcon;